export enum AUTH_STATUS {
  UNAUTHENTICATED = "UNAUTHENTICATED",
  AUTHENTICATED = "AUTHENTICATED",
  TOKEN_EXPIRED = "TOKEN_EXPIRED",
  INVALID_TOKEN = "INVALID_TOKEN",
  VERIFY_EMAIL_REQUIRED = "VERIFY_EMAIL_REQUIRED",
  CHANGE_PASSWORD_REQUIRED = "CHANGE_PASSWORD_REQUIRED",
  EMAIL_VERIFICATION_AND_PASSWORD_CHANGE_REQUIRED = "EMAIL_VERIFICATION_AND_PASSWORD_CHANGE_REQUIRED"
}

export enum LOGOUT_STATUS {
  LOGGED_OUT = "LOGGED_OUT",
  TOKEN_ALREADY_EXPIRED = "TOKEN_ALREADY_EXPIRED"
}
